import { ApprovalService } from '@/modules/global-settings/security/services/approval.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

const approvalService = new ApprovalService();

export const state = {
  approvalLevels: [],
  approvalPolicy: []
};

export const mutations = {
  ...make.mutations(state),

  ADD_APPROVAL_LEVEL: (state, payload) => {
    state.approvalLevels.push(payload);
  },

  UPDATE_APPROVAL_POLICY: (state, { payload }) => {
    const index = state.approvalPolicy.findIndex(
      (el) => el.loan_type == payload.loan_type
    );
    state.approvalPolicy.splice(index, 1, payload);
  },

  UPDATE_APPROVAL_LEVEL_ACTIVITY: (state, { payload }) => {
    state.approvalPolicy.forEach((el) => {
      el.level_active = payload;
    });
  },

  DELETE_APPROVAL_LEVEL: (state, id) => {
    const index = state.approvalLevels.findIndex((el) => el.id == id);
    state.approvalLevels.splice(index, 1);
  }
};

export const actions = {
  fetchApprovals: async ({ commit, dispatch }) => {
    try {
      const { data } = await approvalService.findAll();

      const levels = data.reduce((acc, cur) => {
        acc = acc.concat(cur);
        return acc;
      });

      commit('SET_APPROVAL_LEVELS', levels);

      if (levels.length > 0) {
        dispatch('approvalModule/findApprovalPolicy', levels[0], {
          root: true
        });
      }
    } catch (error) {
      Logger.error('fetching approval levels');
      throw error;
    }
  },

  createApproval: async ({ commit, dispatch }, payload) => {
    try {
      await approvalService.create({
        approval_level: payload,
        level_active: true
      });
      commit('ADD_APPROVAL_LEVEL', payload);
      dispatch('approvalModule/findApprovalPolicy', payload, { root: true });
    } catch (error) {
      Logger.error('create approval level');
      throw error;
    }
  },

  updateApprovalPolicy: async ({ commit }, payload) => {
    try {
      const approval = { ...payload };
      approval.approval_level = approval.name;
      approval.staff_amount = Number(approval.staff_amount);
      approval.member_amount = Number(approval.member_amount);
      await approvalService.updateApprovalPolicy(approval);
      commit('UPDATE_APPROVAL_POLICY', { payload });
    } catch (error) {
      Logger.error('updating approval level');
      throw error;
    }
  },

  toggleApprovalLevelActivity: async ({ commit }, payload) => {
    try {
      await approvalService.updateLevelActive(payload);
      commit('UPDATE_APPROVAL_LEVEL_ACTIVITY', {
        payload: payload.level_active
      });
    } catch (error) {
      Logger.error('updating approval level');
      throw error;
    }
  },

  toggleApprovalPolicyActivity: async ({ commit }, payload) => {
    try {
      const approval = { ...payload };
      approval.approval_level = payload.name;
      await approvalService.updateLoanTypeActive(approval);
      commit('UPDATE_APPROVAL_POLICY', { payload });
    } catch (error) {
      Logger.error('updating approval level');
      throw error;
    }
  },

  findApprovalPolicy: async ({ commit }, id) => {
    try {
      const { data } = await approvalService.findOne(id);

      commit('SET_APPROVAL_POLICY', data);
    } catch (error) {
      Logger.error('finding approval policy');
      throw error;
    }
  },

  deleteApproval: async ({ commit }, id) => {
    try {
      await approvalService.delete(id);
      commit('DELETE_APPROVAL_LEVEL', id);
    } catch (error) {
      Logger.error('deleting approval policy');
      throw error;
    }
  }
};

export const getters = {
  ...make.getters(state)
};
